import { ArrowLeft, Calendar, Image as ImageIcon, Menu, X } from 'lucide-react';
import { StatusPill, AiBadge } from './cockpit/Cockpit';

const panelTitles = {
  photos: 'Photos', upload: 'Upload Photos', collections: 'Collections', headshots: 'Headshot Deliveries',
  frames: 'Photo Frames', share: 'Share Links', deliveries: 'Deliveries', analytics: 'Analytics', settings: 'Settings',
};

const panelDescriptions = {
  photos: 'Browse, search, and manage gallery photos',
  upload: 'Upload new photos with AI processing',
  collections: 'Organise photos into groups',
  headshots: 'Deliver photos by face',
  frames: 'Branded frame overlays',
  share: 'Manage share links and send invitations',
  deliveries: 'Email delivery history',
  analytics: 'Gallery statistics and download logs',
  settings: 'Configure gallery settings and finalisation',
};

const GalleryHeader = ({ gallery, onBack, activePanel, onMenuToggle, mobileMenuOpen }) => {
  return (
    <header className="flex items-center font-tac-body" style={{ height: 64, background: '#fff', borderBottom: '1px solid #E4E4E9', padding: '0 clamp(12px,2vw,24px)' }}>
      {/* Mobile menu toggle */}
      <button onClick={onMenuToggle} className="md:hidden" style={{ marginRight: 8, background: 'transparent', border: 'none', color: '#55555C', cursor: 'pointer', display: 'flex' }}>
        {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {/* Left: Back + gallery info */}
      <div className="flex items-center gap-2 md:gap-4 min-w-0 flex-shrink">
        <button onClick={onBack} className="font-tac-heading hidden md:flex items-center gap-1 flex-shrink-0" style={{ marginLeft: -8, color: '#55555C', fontWeight: 600, fontSize: 13, background: 'transparent', border: 'none', cursor: 'pointer' }}>
          <ArrowLeft className="w-4 h-4" /> Back
        </button>
        <div className="hidden md:block flex-shrink-0" style={{ height: 24, width: 1, background: '#E4E4E9' }} />

        <div className="flex items-center gap-2 md:gap-3 min-w-0">
          {(gallery?.cover_image_url || gallery?.featured_thumbnail_url) ? (
            <div className="overflow-hidden flex-shrink-0" style={{ width: 36, height: 36, borderRadius: 8, border: '1px solid #E4E4E9' }}>
              <img src={gallery.cover_image_url || gallery.featured_thumbnail_url} alt={gallery.name} className="w-full h-full object-cover" />
            </div>
          ) : (
            <div className="flex items-center justify-center flex-shrink-0" style={{ width: 36, height: 36, borderRadius: 8, background: '#F2F2F5' }}>
              <ImageIcon className="w-4 h-4" style={{ color: '#9A9AA0' }} />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="font-tac-heading leading-tight truncate" style={{ fontSize: 15, fontWeight: 700, color: '#141414', maxWidth: 'min(42vw, 300px)' }}>
              {gallery?.name || 'Loading…'}
            </h1>
            <div className="flex items-center gap-2 font-tac-mono" style={{ fontSize: 10.5, color: '#9A9AA0', letterSpacing: '0.04em' }}>
              {gallery?.event_date && (
                <span className="flex items-center gap-1">
                  <Calendar className="w-3 h-3" />
                  {new Date(gallery.event_date).toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }).toUpperCase()}
                </span>
              )}
              {gallery?.finalized && <span className="hidden sm:inline"><StatusPill tone="success">Finalized</StatusPill></span>}
            </div>
          </div>
        </div>
      </div>

      {/* Center: panel title */}
      <div className="flex-1 hidden lg:flex justify-center px-4">
        <div className="text-center">
          <h2 className="font-tac-heading" style={{ fontSize: 14, fontWeight: 700, color: '#141414' }}>{panelTitles[activePanel] || ''}</h2>
          <p style={{ fontSize: 12, color: '#9A9AA0' }}>{panelDescriptions[activePanel] || ''}</p>
        </div>
      </div>
      <div className="flex-1 flex justify-center lg:hidden px-2">
        <span className="font-tac-heading" style={{ fontSize: 14, fontWeight: 600, color: '#55555C' }}>{panelTitles[activePanel] || ''}</span>
      </div>

      {/* Right */}
      <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
        {(gallery?.ai_top30_enabled || gallery?.ai_top_30_enabled) && <span className="hidden sm:inline"><AiBadge>AI Top 30</AiBadge></span>}
        <button onClick={onBack} className="md:hidden" style={{ background: 'transparent', border: 'none', color: '#55555C', cursor: 'pointer', display: 'flex' }}>
          <ArrowLeft className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
};

export default GalleryHeader;
